<template>
  <div>
    <div class="card data-table mb-5 mb-xl-10">
      <div class="card-header py-3">
        <div style="padding: 10px; font-size: 18px; font-weight: 600; color: #32325d">Doanh thu theo khách hàng</div>
      </div>
      <div class="card-body">
        <div class="col-md-12 tbl">
          <!--        header-row-class-name="thead-light"-->
          <el-table :data="tableData" header-row-class-name="thead-light" style="height: 100%" fit stripe
            highlight-current-row v-loading="isLoading">
            <el-table-column label="Khách hàng" width="400" header-align="center">
              <template #default="scope">
                {{ scope.row.odooName }}
                <span v-if="scope.row.odooPhone">
                  <{{ scope.row.odooPhone }}>
                </span>
              </template>
            </el-table-column>
            <el-table-column label="Tổng giá trị đơn hàng" header-align="center">
              <template #default="scope">
                <div style="background-color: #b5dffb; padding: 5px 10px 5px 5px"
                  :style="{ marginLeft: scope.row.mlTongTien }">{{ convertToMoney(scope.row.tongTien) }}</div>
              </template>
            </el-table-column>
            <el-table-column label="Tổng đơn hàng" header-align="center">
              <template #default="scope">
                <div style="background-color: #c5f9c3; padding: 5px 10px 5px 5px"
                  :style="{ marginLeft: scope.row.mlTongDon }">{{ scope.row.tongDon }}</div>
              </template>
            </el-table-column>
            <!--          <el-table-column prop="nCuoiKy" label="Cuối kỳ" align="center" width="120" />-->
          </el-table>
        </div>
      </div>

    </div>

  </div>
</template>
<script>
import { baseUrl } from "@/utils/global";
import moment from "moment/moment";
import { convertToMoney } from "@/utils/stringUtils";
import { Report } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";

export default {
  data() {
    return {
      store: useStore(),
      baseUrl: baseUrl,
      isLoading: false,
      tableData: [
        { partnerName: "Abcd", tongTien: 10, tongDon: 5 },
        { partnerName: "Efg", tongTien: 7, tongDon: 3 },
        { partnerName: "Gdfs", tongTien: 8, tongDon: 2 },
      ],
      search: {
        createDate: [moment().add(-30, 'days'), moment()],
      },
      pageRequest: { pageNum: 1, pageSize: 30 },

    }
  },
  methods: {
    async getPartnerRevenue() {
      const res = await this.store.dispatch(Report.partnerRevenue)
      if (res.code === 200) this.tableData = res.data

      const maxTongTien = Math.max(...this.tableData.map(obj => obj.tongTien));
      const maxTongDon = Math.max(...this.tableData.map(obj => obj.tongDon));

      this.tableData.forEach(e => {
        e.mlTongTien = 100 - (e.tongTien / maxTongTien * 100) + "%"
        e.mlTongDon = 100 - (e.tongDon / maxTongDon * 100) + "%"
      })
    },

    convertToMoney(num) {
      return convertToMoney(num) + "đ"
    }

  },
  mounted() {
    this.getPartnerRevenue()
  }
}

</script>
